module.exports = __webpack_public_path__ + "static/media/cbre.1addd4f1.png";